import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultDrivingBehavior = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as DrivingBehaviorEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<DrivingBehaviorEditCriteria>,
}

export interface DrivingBehaviorEditCriteria {
  compliance: boolean;
  description: string;
}
